/* Velion Produktinfo-Bloecke - gemeinsames JS (Accordion, Scroll-Link, Preis).
   Die Videosteuerung liegt bewusst getrennt in assets/velion-video.js. */
(function () {
  'use strict';
  var $$ = function (r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); };

  function initAccordion(root) {
    $$(root, '.velion-acc').forEach(function (a) {
      if (a.dataset.vInit === '1') return; a.dataset.vInit = '1';
      var single = a.dataset.single === 'true';
      var items = $$(a, '.velion-acc__item');
      items.forEach(function (it) {
        var btn = it.querySelector('.velion-acc__trigger');
        var panel = it.querySelector('.velion-acc__panel');
        if (!btn || !panel) return;
        function setOpen(open) {
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          it.classList.toggle('is-open', open);
          panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
          panel.hidden = false;
        }
        setOpen(btn.getAttribute('aria-expanded') === 'true');
        btn.addEventListener('click', function () {
          var willOpen = btn.getAttribute('aria-expanded') !== 'true';
          if (willOpen && single) items.forEach(function (o) {
            if (o === it) return;
            var ob = o.querySelector('.velion-acc__trigger');
            var op = o.querySelector('.velion-acc__panel');
            if (ob && op) { ob.setAttribute('aria-expanded', 'false'); o.classList.remove('is-open'); op.style.maxHeight = '0px'; }
          });
          setOpen(willOpen);
        });
        panel.addEventListener('transitionend', function () {
          if (it.classList.contains('is-open')) panel.style.maxHeight = 'none';
        });
      });
      window.addEventListener('resize', function () {
        $$(a, '.velion-acc__item.is-open .velion-acc__panel').forEach(function (p) { p.style.maxHeight = 'none'; });
      });
    });
  }

  function initScroll(root) {
    $$(root, '.velion-rev[data-target]').forEach(function (el) {
      if (el.dataset.vInit === '1') return; el.dataset.vInit = '1';
      el.addEventListener('click', function () {
        var sel = (el.dataset.target || '').trim();
        if (!sel) return;
        if (!/^[#.][A-Za-z0-9_\-]+$/.test(sel)) return;
        var t;
        try { t = document.querySelector(sel); } catch (e) { return; }
        if (!t) return;
        var off = parseInt(el.dataset.offset || '0', 10) || 0;
        var y = t.getBoundingClientRect().top + window.pageYOffset - off;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }

  function initPrice(root) {
    $$(root, '.velion-pi[data-price-sync="true"]').forEach(function (pi) {
      if (pi.dataset.vInit === '1') return; pi.dataset.vInit = '1';
      var map;
      var raw = pi.querySelector('.velion-pi__data');
      try { map = JSON.parse(raw ? raw.textContent : '{}'); } catch (e) { return; }
      var form = document.getElementById('product-form-' + pi.dataset.section);
      if (!form) return;
      var input = form.querySelector('input[name="id"]');
      if (!input) return;
      var elPrice = pi.querySelector('.velion-pi__price');
      var elCompare = pi.querySelector('.velion-pi__compare');
      var elBadge = pi.querySelector('.velion-pi__badge-text');
      function apply() {
        var d = map[input.value];
        if (!d) return;
        if (elPrice) elPrice.innerHTML = d.p;
        if (elCompare) { elCompare.innerHTML = d.c || ''; elCompare.hidden = !d.c; }
        if (elBadge && elBadge.dataset.auto === 'true') {
          if (d.s > 0) { elBadge.textContent = (elBadge.dataset.tpl || 'SPAREN SIE [percentage]').replace('[percentage]', d.s + '%'); elBadge.parentNode.hidden = false; }
          else { elBadge.parentNode.hidden = true; }
        }
      }
      apply();
      new MutationObserver(apply).observe(input, { attributes: true, attributeFilter: ['value'] });
      form.addEventListener('change', function () { setTimeout(apply, 0); });
    });
  }

  function boot(root) {
    root = root || document;
    initAccordion(root); initScroll(root); initPrice(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) { boot(e.target.parentNode || document); });
})();
